import {JsonProperty} from 'json-typescript-mapper';
import { Contact } from './contact.model';

export class User {
  @JsonProperty('id')
  public id?: number;

  @JsonProperty('login')
  public login?: string;

  @JsonProperty('firstName')
  public firstName?: string;

  @JsonProperty('lastName')
  public lastName?: string;

  @JsonProperty('email')
  public email?: string;

  @JsonProperty('activated')
  public activated?: boolean;

  @JsonProperty('langKey')
  public langKey?: string;

  @JsonProperty('contact')
  public contact?: Contact;

  @JsonProperty('training')
  public training?: boolean;

  constructor() {
    this.id = void 0;
    this.login = void 0;
    this.firstName = void 0;
    this.lastName = void 0;
    this.email = void 0;
    this.activated = void 0;
    this.langKey = void 0;
    this.contact = void 0;
    this.training = void 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/user.model.ts